<template>
	<van-tabbar route v-model="active" active-color="#ff550a" inactive-color="#717784">
		<van-tabbar-item replace to="/">
			<span>推荐</span>
			<img slot="icon" slot-scope="props" :src="props.active ? index.active : index.normal">
		</van-tabbar-item>
		<van-tabbar-item replace to="/live" @click="goCourseList">
			<span>课程</span>
			<img slot="icon" slot-scope="props" :src="props.active ? course.active : course.normal">
		</van-tabbar-item>
		<van-tabbar-item replace to="/video" @click="goVideoList">
			<span>视频</span>
			<img slot="icon" slot-scope="props" :src="props.active ? video.active : video.normal">
		</van-tabbar-item>
		<van-tabbar-item replace to="/buy" @click="goBuyList">
			<span>已购</span>
			<img slot="icon" slot-scope="props" :src="props.active ? buy.active : buy.normal">
		</van-tabbar-item>
		<van-tabbar-item replace to="/personal">
			<span>我的</span>
			<img slot="icon" slot-scope="props" :src="props.active ? wode.active : wode.normal">
		</van-tabbar-item>
	</van-tabbar>
</template>
<script>
	import { Tabbar, TabbarItem } from 'vant';
	export default{
		components:{
			[Tabbar.name]: Tabbar,
			[TabbarItem.name]: TabbarItem
		},
		data() {
			return {
				active: 0,
				index: {
					normal: '../../static/images/tuijian2.png',
					active: '../../static/images/tuijian.png'
				},
				course: {
					normal: '../../static/images/kecheng2.png',
					active: '../../static/images/kechen.png'
				},
				video: {
					normal: '../../static/images/shipin2.png',
					active: '../../static/images/shipin.png'
				},
				buy: {
					normal: '../../static/images/yigou2.png',
					active: '../../static/images/yigou.png'
				},
				wode: {
					normal: '../../static/images/wode2.png',
					active: '../../static/images/wode.png'
				}
			}
		},
		methods:{
			goCourseList(){
				window.location.href = this.login.pageUrl + '/live';
			},
			goVideoList(){
				window.location.href = this.login.pageUrl + '/video';
			},
			goBuyList(){
				window.location.href = this.login.pageUrl + '/buy';
			}
		}
	}
</script>
<style lang="css" scoped>
	.van-tabbar{box-shadow: 0px -1px 4px 0px rgba(11,11,11,0.1);}
	.van-tabbar-item{font-size: 2.67vw;}
	.van-tabbar-item--active{color: #ff550a;}
	.van-tabbar-item__icon img{height: 5.07vw;}
</style>


// WEBPACK FOOTER //
// src/components/footer.vue